(() => {
  // Read-only mirror of Shopify's active mobile gallery image.
  // Does not write variant selectors, price, product form, or gallery state.
  let scheduled = false;
  const update = () => {
    if (!matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.product-information').forEach(section => {
      const thumbnail = section.querySelector('variant-picker .tbv-static-preview img');
      const gallery = section.querySelector('media-gallery');
      if (!thumbnail || !gallery) return;
      // Shopify slideshow marks its currently visible slide with aria-hidden=false.
      const active = gallery.querySelector('slideshow-slide[aria-hidden="false"] img');
      const candidate = active || gallery.querySelector('slideshow-slide:not([aria-hidden="true"]) img');
      if (!candidate) return;
      const next = candidate.currentSrc || candidate.src;
      if (!next) return;
      if (thumbnail.dataset.tbvSource !== next) {
        thumbnail.dataset.tbvSource = next;
        thumbnail.src = next;
      }
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled=false; update(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['aria-hidden','src','srcset']});
})();
